import { useRouter } from 'next/router';
import { useEffect } from 'react';

declare global {
  interface Window {
    Produktly: any;
  }
}

export const ProduktlyProvider = () => {
  const router = useRouter();

  useEffect(() => {
    if (!window.Produktly) return;

    window.Produktly.configure({
      redirect: (url: string) => {
        router.push(url);
      },
    });
  }, [window.Produktly]);

  return null;
};
